import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M137.675 301.853H405.57a17.28 17.28 0 0 0 15.728-10.197l69.134-155.552a17.284 17.284 0 0 0-15.728-24.37H109.676L94.466 38.97a17.284 17.284 0 0 0-17.284-13.654h-51.85a17.284 17.284 0 0 0 0 34.567h37.85l45.975 214.835a59.974 59.974 0 0 0 10.37 110.442 59.3 59.3 0 0 0-7.777 29.036 60.492 60.492 0 0 0 120.984 0 59.6 59.6 0 0 0-6.049-25.925h63.95a59.6 59.6 0 0 0-6.05 25.925 60.492 60.492 0 0 0 120.985 0 59.6 59.6 0 0 0-6.05-25.925h23.334a17.284 17.284 0 0 0 0-34.567h-285.18a25.925 25.925 0 0 1 0-51.851m60.492 112.343a25.925 25.925 0 1 1-25.925-25.925 25.925 25.925 0 0 1 25.925 25.925m172.836 0a25.925 25.925 0 1 1-25.925-25.925 25.925 25.925 0 0 1 25.925 25.925m77.085-267.895-53.752 120.985H143.033L117.107 146.3Z",
      "data-name": "Layer 21"
    }, null, -1)
  ])))
}
export default { render: render }